import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ArticleSharingService } from 'src/app/services/article-sharing.service';
import { ArticleService } from 'src/app/services/article.services';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CartService } from 'src/app/services/cart.services';
import { CAtegorieService } from 'src/app/services/categorie.services';
import { ScriptLoaderService } from 'src/app/services/script-loader.services';
import { WishlistService } from 'src/app/services/wishlist.service';

declare var bootstrap: any;

@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.css']
})
export class ShopComponent implements OnInit {
  scripts = [
    'assets/js/jquery.min.js',
    'assets/js/bootstrap.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/carousel.js',
    'assets/js/bootstrap-select.min.js',
    'assets/js/lazysize.min.js',
    'assets/js/count-down.js',
    'assets/js/wow.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/multiple-modal.js',
    'assets/js/nouislider.min.js',
    'assets/js/shop.js',
    'assets/js/main.js'

  ];
  cartItems: any[] = [];
  articles: any[] = [];
  selectedArticle: any = null;
  quantity: number = 1;
articleId: any;
 wishlistCount: number = 0;
  cartCount: number = 0;
  selectedTeinte: string = ''; // Libellé de la teinte sélectionnée
  selectedVariant: any; // Va
categoryLabel: string = '';
currentPage: number = 1;
articlesPerPage: number = 12;
totalItems: number = 0;
totalPages: number = 0;
pages: number[] = [];
categories: any[] = [];
sousSousCategories: any[] = [];
subCategories: any[]= [];
selectedSubCategoryLabel: string = '';
Marques: any[] = [];
categoryId: number = 0; // on va stocker l'id de catégorie ici

  constructor(private scriptLoader: ScriptLoaderService,private authService: AuthServiceService ,private articleSharingService: ArticleSharingService, private wishlist : WishlistService,  private cartService :CartService ,  private cdr: ChangeDetectorRef , private articleservice: ArticleService,  private router: Router,private route: ActivatedRoute,  private categoryService: CAtegorieService,) { }


  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const categoryId = +params['id'];
      const categoryLabel = params['libelle'];
      const subCategoryId = params['subCategoryId'] ? +params['subCategoryId'] : 0; // Nouvelle ligne 🔥

      this.categoryLabel = categoryLabel.replace(/-/g, ' ');
      console.log('Catégorie:', categoryId, categoryLabel, 'Sous-catégorie:', subCategoryId);

      const page = params['page'] ? +params['page'] : 1;
      this.currentPage = page;

      this.categoryId = categoryId;
      this.selectedSubCategoryId = subCategoryId; // Très important !!

      // Construire le requestBody en fonction de la sous-catégorie
      const requestBody = {
        nbre_page: this.currentPage,
        nbre_article: 12,
        order_by: 'id',
        search: '',
        prix_min: 0,
        prix_max: 2000,
        id_categorie: categoryId,
        id_marque: 0,
        id_sous_categorie: subCategoryId, // 🔥 Important
        id_sous_sous_categorie: 0
      };

      this.articleservice.getArticlesByFilters(requestBody).subscribe((response: any) => {
        this.articles = response;
        this.totalItems = response[0]?.count || 0;
        this.totalPages = Math.ceil(this.totalItems / 12);
        this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);

        this.articles.forEach((article, index) => {
          this.articleservice.getArticlesById(article.id).subscribe(detailedArticle => {
            this.articles[index].details_variant = detailedArticle.details_variant;
          });
        });

        if (this.articles.length > 0 && this.articles[0].details_variant?.length > 0) {
          this.selectTeinte(this.articles[0].details_variant[0]);
        }
      });
      this.categoryId = categoryId;
    });
   this.articleSharingService.currentCategoryLabel.subscribe(label => {
  if (label) {
    this.categoryLabel = label;
  }
});



    this.articleservice.getArticlesById(this.articleId).subscribe((data) => {
      this.article = data;

      // Sélectionner la première variante par défaut
      if (this.article.details_variant?.length > 0) {
        this.selectTeinte(this.article.details_variant[0]);
      }
    });
    this.scriptLoader.loadScripts(this.scripts);
     this.cartService.cart$.subscribe(cart => {
      this.cartItems = cart;
      this.cartCount = cart.reduce((total, item) => total + item.quantity, 0);
    });
      this.wishlist.wishlist$.subscribe(wishlist => {
      this.wishlistCount = this.wishlist.getWishlistCount();
    });
    this.categoryService.getCategories().subscribe((data) => {
      this.categories = data;  // Les catégories principales
    });
    this.loadMarquesByCategorie(this.categoryId);


    this.getSousCategoriesForCategory(this.categoryId);
    this.quantity = 1;

  }
  ngAfterViewInit(): void {
    document.addEventListener('hidden.bs.offcanvas', () => {
      setTimeout(() => {
        const backdrops = document.querySelectorAll('.offcanvas-backdrop');
        const anyOpen = document.querySelector('.offcanvas.show');

        // Supprimer les backdrops s'il n'y a plus de modals ouverts
        if (!anyOpen) {
          backdrops.forEach(b => b.remove());

          // Supprimer modal-open uniquement si nécessaire
          document.body.classList.remove('modal-open');
          document.body.style.overflow = ''; // réactive le scroll
        }
      }, 200); // laisser Bootstrap faire en premier
    });

  }
  selectedBrandId: number | null = null;
  filtrerParMarque(brandId: number | null): void {
    this.selectedBrandId = brandId;
    console.log('Marque sélectionnée :', brandId);




 // this.nbre_page=1;
    this.applyFilters();

  }
  onCheckboxChange(event: Event, brandId: number): void {
    const checkbox = event.target as HTMLInputElement;
    this.selectedBrandId = checkbox.checked ? brandId : null;
    this.filtrerParMarque(this.selectedBrandId);
  }
 goToAccount(event: Event): void {
    event.preventDefault(); // évite le rechargement

    if (this.authService.getClientId() !== null) {
      this.router.navigate(['/account']);
    } else {
      this.router.navigate(['/login']);
    }
  }
  applyFilters(): void {
    this.selectedSubCategoryId = 0;
    this.selectedSubCategoryLabel = this.categoryLabel; // ⬅️ réinitialise le label affiché

    const requestBody = {
      id_sous_categorie: 0, // Tous
      nbre_page: 1,
      nbre_article: this.articlesPerPage,
      order_by: 'id',
      search: '',
      prix_min: 0,
      prix_max: 2000,
      id_marque: this.selectedBrandId || 0,
      id_categorie: this.categoryId
    };

    this.articleservice.getArticlesByFilters(requestBody).subscribe((response: any) => {
      this.articles = response;
      this.totalItems = response[0]?.count || 0;
      this.totalPages = Math.ceil(this.totalItems / this.articlesPerPage);
      this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
      this.currentPage = 1;

      this.articles.forEach((article, index) => {
        this.articleservice.getArticlesById(article.id).subscribe(detailedArticle => {
          this.articles[index].details_variant = detailedArticle.details_variant;
        });
      });

      if (this.articles.length > 0 && this.articles[0].details_variant?.length > 0) {
        this.selectTeinte(this.articles[0].details_variant[0]);
      }

      // 🔁 Met à jour l’URL sans sous-catégorie
      this.router.navigate(['/categorie', this.categoryId, this.categoryLabel], {
        queryParams: { page: 1 },
        queryParamsHandling: 'merge'
      });
    });
  }


  onQuantityChange(value: any): void {
    const parsed = parseInt(value, 10);
    this.quantity = isNaN(parsed) || parsed < 1 ? 1 : parsed;
    this.updateTotalPrice(this.selectedArticle);
  }


getSousCategoriesForCategory(categoryId: number): void {
  if (!categoryId) {
    console.warn("Aucune catégorie sélectionnée.");
    this.subCategories = []; // Réinitialiser si aucune catégorie
    return;
  }

  this.categoryService.getSousCategories().subscribe(
    (response: any[]) => {
      console.log("Toutes les sous-catégories :", response);

      // Vérifie que categoryId est bien un nombre
      const parsedCategoryId = Number(categoryId);

      // ✅ Utilise `id_categorie_mere` pour filtrer
      this.subCategories = response.filter(
        (sousCategorie) => Number(sousCategorie.id_categorie_mere) === parsedCategoryId
      );

      console.log("Sous-catégories pour la catégorie sélectionnée :", this.subCategories);
    },
    (error) => {
      console.error('Erreur lors du chargement des sous-catégories :', error);
    }
  );
}
selectSubCategory(subCategoryId: number): void {
  console.log('Sous-catégorie sélectionnée (ID) :', subCategoryId);

  // Mettre à jour l'ID de la sous-catégorie sélectionnée
  this.selectedSubCategoryId = subCategoryId;
 // 🔥 Récupérer le libellé de la sous-catégorie sélectionnée
 const selectedSubCat = this.subCategories.find(sc => sc.id === subCategoryId);
 this.selectedSubCategoryLabel = selectedSubCat ? selectedSubCat.libelle : '';
  // Construire la requête pour récupérer les produits
  const requestBody = {
    id_sous_categorie: subCategoryId,
    nbre_page: 1,  // Page initiale (peut être mis à jour avec pagination)
    nbre_article: this.articlesPerPage,  // Nombre d'articles par page
    order_by: 'id',
    search: '',
    prix_min: 0,
    prix_max: 2000,
    id_categorie: this.categoryId // Assure-toi que tu as l'ID de la catégorie
  };

  // Appel à l'API pour récupérer les produits de la sous-catégorie
  this.articleservice.getArticlesByFilters(requestBody).subscribe(
    (response: any) => {
      // Stocker les produits dans une variable locale
      this.articles = response;
      console.log('Produits récupérés pour la sous-catégorie', subCategoryId, ':', response);

      // Calculer le nombre total d'articles et le nombre total de pages
      this.totalItems = response[0]?.count || 0;
      this.totalPages = Math.ceil(this.totalItems / this.articlesPerPage);
      this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);

      // Réinitialiser la page actuelle à 1 chaque fois qu'une nouvelle sous-catégorie est sélectionnée
      this.currentPage = 1;

      // Charger les variantes des articles (optionnel)
      this.articles.forEach((article, index) => {
        this.articleservice.getArticlesById(article.id).subscribe(detailedArticle => {
          this.articles[index].details_variant = detailedArticle.details_variant;
        });
      });

      // Sélectionner la première variante par défaut si des variantes sont présentes
      if (this.articles.length > 0 && this.articles[0].details_variant?.length > 0) {
        this.selectTeinte(this.articles[0].details_variant[0]);
      }
      //this.closeFilterModal();
    },
    (error) => {
      console.error('Erreur lors de la récupération des produits pour la sous-catégorie', subCategoryId, ':', error);
    }
  );
}

selectedSubCategoryId: number = 0;

loadPage(page: number): void {
  const requestBody = {
    nbre_page: page,
    nbre_article: this.articlesPerPage,
    order_by: 'id',
    search: '',
    prix_min: 0,
    prix_max: 2000,
    id_categorie: this.categoryId,
    id_marque: 0,
    id_sous_categorie: this.selectedSubCategoryId || 0,
    id_sous_sous_categorie: 0
  };

  this.articleservice.getArticlesByFilters(requestBody).subscribe((response: any) => {
    this.articles = response;

    this.totalItems = response[0]?.count || 0;
    this.totalPages = Math.ceil(this.totalItems / this.articlesPerPage);
    this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);

    this.currentPage = page;

    this.articles.forEach((article, index) => {
      this.articleservice.getArticlesById(article.id).subscribe(detailedArticle => {
        this.articles[index].details_variant = detailedArticle.details_variant;
      });
    });

    if (this.articles.length > 0 && this.articles[0].details_variant?.length > 0) {
      this.selectTeinte(this.articles[0].details_variant[0]);
    }
  });

  // Maintenant, tu dois bien router avec tous les paramètres
  if (this.selectedSubCategoryId) {
    this.router.navigate(['/categorie', this.categoryId, this.categoryLabel, this.selectedSubCategoryId, this.getSubCategoryLabel(this.selectedSubCategoryId)], {
      queryParams: { page: page },
      queryParamsHandling: 'merge'
    });
  } else {
    this.router.navigate(['/categorie', this.categoryId, this.categoryLabel], {
      queryParams: { page: page },
      queryParamsHandling: 'merge'
    });
  }
}
getSubCategoryLabel(subCategoryId: number): string {
  const subCategory = this.subCategories.find(sc => sc.id === subCategoryId);
  return subCategory ? subCategory.libelle.replace(/\s+/g, '-').toLowerCase() : '';
}


loadMarquesByCategorie(idCategorie?: number): void {
  console.log("ayoub ")
  this.Marques = []; // Réinitialise la liste des marques
  this.cdr.detectChanges(); // Force la détection des changements

  const params: any = {};

  if (idCategorie) {
    params.id_categorie = idCategorie;
  }

  this.categoryService.getMarquesByCategorie(params).subscribe(
    (data) => {
      this.Marques = data;
      console.log("marques", this.Marques);
      this.cdr.detectChanges(); // Force l'interface à se mettre à jour
    },
    (error) => {
      console.error('Erreur lors du chargement des marques', error);
    }
  );
}
  // closeFilterModal(): void {
  //   const modal = document.getElementById('filterShop');
  //   if (modal) {
  //     modal.classList.remove('show');
  //     modal.style.display = 'none';
  //     document.body.classList.remove('modal-open');
  //     const backdrops = document.getElementsByClassName('modal-backdrop');
  //     while (backdrops.length > 0) {
  //       backdrops[0].parentNode?.removeChild(backdrops[0]);
  //     }
  //   }}


  goToProduct(articleId: number, libelle: string): void {
    if (!articleId || !libelle) {
      console.error("Erreur : ID ou libellé manquant !");
      return;
    }
    const formattedLibelle = libelle.toLowerCase().replace(/ /g, '-');
    const url = `/singleproduct/${formattedLibelle}/${articleId}`;
    console.log("Navigating to:", url);
    this.router.navigate([url]);
  }
  openQuickView(article: any) {
    this.selectedArticle = article;

    // Sélectionner la première teinte par défaut si disponible
    if (this.selectedArticle.details_variant?.length > 0) {
      this.selectTeintes(this.selectedArticle.details_variant[0]);
    }
    console.log("hhhhhhh",this.selectedArticle);
  }
  openQuickAdd(article: any) {
    this.selectedArticle = article;

    // Sélectionner la première teinte par défaut si disponible
    if (this.selectedArticle.details_variant?.length > 0) {
      this.selectTeintes(this.selectedArticle.details_variant[0]);
    }
    console.log("hhhhhhh",this.selectedArticle);
  }
  article: any;
  selectTeinte(variant: any) {
    this.selectedTeinte = variant.libelle;
    this.quantity = 1;

    // Mettre à jour les propriétés de l'article directement
    this.article.libelle = variant.libelle;
    this.article.description = variant.description;
    this.article.plus_details = variant.plus_details;
    this.article.images[0].data = variant.images;
  }

  selectTeintes(variant: any) {
    this.selectedTeinte = variant.libelle;
    this.quantity = 1;

    // Mettre à jour les propriétés de l'article directement
    this.selectedArticle.libelle = variant.libelle;
    this.selectedArticle.description = variant.description;
    this.selectedArticle.plus_details = variant.plus_details;
    this.selectedArticle.images[0].data = variant.images;
  }


  getTeinteColor(libelle: string): string {
    const variant = this.article.details_variant.find(
      (variant: { libelle: string; }) => variant.libelle === libelle
    );
    return variant ? variant.icon_color : 'transparent'; // Retourne la couleur ou transparent si non trouvé
  }
  addToCart(event: Event, product: any, quantity: number): void {
    event.preventDefault();

    if (product.details_variant?.length > 0 && !this.selectedTeinte) {

        return;
    }

    const updatedProduct = { ...product };
    let variant = null;

    if (this.selectedTeinte) {
        const selectedVariant = product.details_variant.find((v: any) => v.libelle === this.selectedTeinte);

        if (selectedVariant) {
            // Gestion spécifique des images en base64
            if (selectedVariant.images && selectedVariant.images.length > 0) {
                // Convertir le tableau de strings en tableau d'objets {data: string}
                updatedProduct.images = selectedVariant.images.map((img: string) => ({ data: img }));
            } else {
                // Fallback aux images originales si pas d'images spécifiques
                updatedProduct.images = [...product.images];
            }

            updatedProduct.libelle = `${product.libelle} - ${selectedVariant.libelle}`;
            updatedProduct.description = selectedVariant.description || product.description;
            updatedProduct.plus_details = selectedVariant.plus_details || product.plus_details;
            updatedProduct.selectedColor = selectedVariant.libelle;
            variant = selectedVariant.libelle;
        }
    }

    this.cartService.addToCart(updatedProduct, quantity, variant);
    this.loadCartItems();
    this.openCartManuellement();


}
addToWishlist(product: any): void {
  this.wishlist.addToWishlist(product);

}
loadCartItems(): void {
  this.cartItems = this.cartService.getCartItems();
}
openCartManuellement(): void {
  const workingButton = document.querySelector('.tf-sticky-atc-infos .btn-add-to-cart') as HTMLElement;
  if (workingButton) {
    workingButton.click();
  }
}


increaseQuantity(article: any): void {
  this.quantity = parseInt(this.quantity as any, 10) || 1;
  this.quantity++;
  this.updateTotalPrice(article);
}

decreaseQuantity(article: any): void {
  this.quantity = parseInt(this.quantity as any, 10) || 1;
  if (this.quantity > 1) {
    this.quantity--;
    this.updateTotalPrice(article);
  }
}


// Met à jour le prix total
updateTotalPrice(article: any): void {
  article.totalPrice = this.quantity * article.prix_ttc;
}
}
